export const {
  Store,
  createLogger,
  createNamespacedHelpers,
  createStore,
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
  storeKey,
  useStore
} = window.Vuex || {};
